// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__ntDxB","rootCenter":"LoadMoreObserver_rootCenter__3tEVy","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2E7VT"};